module.exports = __webpack_public_path__ + "img/SFSW-Off-ON-1.854c8cb3.gif";